/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideIcon64Regular = forwardRef('DivideIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27 18a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" }),
        React.createElement("path", { d: "M9.5 32a1.5 1.5 0 0 1 1.5-1.5h42a1.5 1.5 0 0 1 0 3H11A1.5 1.5 0 0 1 9.5 32Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 41a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-2 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" })));
});
